import "./index.css";

import { App } from "@/app/App.tsx";
import "@/localization/i18next.ts";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

async function enableMocking() {
    if (process.env.APP_ENV !== "msw") {
        return;
    }

    const { worker } = await import("./mocks/browser.ts");

    return worker.start();
}

enableMocking().then(() => {
    const root = createRoot(document.getElementById("root")!);

    root.render(
        <StrictMode>
            <App />
        </StrictMode>
    );
});

